module.exports = __webpack_public_path__ + "static/media/right.9f16b820.svg";